import React from "react";
import {Navigation, Pagination, A11y, Scrollbar, EffectCoverflow} from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.min.css";
import "swiper/modules/pagination/pagination.min.css";
import "swiper/modules/navigation/navigation.min.css";
import "swiper/modules/scrollbar/scrollbar.min.css";
import "swiper/modules/effect-cards/effect-cards.min.css"
import "swiper/modules/effect-coverflow/effect-coverflow.min.css"

function Slider({ projects, onProjectClick }) {
    return (
        <Swiper
            modules={[Navigation, Pagination, A11y, EffectCoverflow, Scrollbar]}
            effect="coverflow"
            coverflowEffect={{
                rotate: 50,
                stretch: 0,
                depth: 100,
                modifier: 1,
                slideShadows: false,
              }}
            spaceBetween={50}
            centeredSlides={true}
            slidesPerView={1}
            initialSlide={1}
            navigation
            pagination={{ clickable: true }}
            loop={true}
        >
            {projects.map((project, index) => (
                <SwiperSlide key={index}>
                    <div
                        className="project-item"
                        onClick={() => onProjectClick(project)}
                    >
                        <img
                            src={project.images[0]}
                            alt={project.title}
                            className="img-project"
                            style={{ width: "100%", height: "300px", objectFit: "contain" }}
                        />
                        <p>{project.startDate}</p>
                        <h3>{project.title}</h3>
                    </div>
                </SwiperSlide>
            ))}
        </Swiper>
    );
}

export default Slider;
